/**
 * Shared helpers for questions whose answer can be either a scalar value or a
 * multi-select array.
 */

/**
 * Returns `true` when the provided answer contains the expected option value.
 *
 * @param {unknown} value - Stored answer value.
 * @param {unknown} expectedValue - Option value to look for.
 * @returns {boolean} Whether the answer contains the requested option.
 */
export function selectionIncludesValue(value, expectedValue) {
  if (Array.isArray(value)) {
    return value.some(
      (entry) => String(entry ?? "") === String(expectedValue ?? ""),
    );
  }

  return String(value ?? "") === String(expectedValue ?? "");
}

/**
 * Returns `true` when a question's "Other" follow-up should be shown.
 *
 * @param {object} question - Question definition.
 * @param {unknown} value - Stored answer value for the question.
 * @returns {boolean} Whether the configured free-text follow-up is active.
 */
export function questionUsesFreeText(question, value) {
  if (!question?.freeTextFieldId) {
    return false;
  }

  return selectionIncludesValue(
    value,
    question.freeTextTriggerValue ?? "Other",
  );
}
